import React, { useEffect, useContext, useState, useMemo, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import MainTemplate from "../templates/MainTemplate"
import {
  Card,
  Checkbox,
  Container,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
} from '@material-ui/core'
import { GlobalContext } from '../../hooks/reducer'
import { actions as loginActions } from '../../hooks/useLoginUserReducer'
import { actions as shareCaseActions } from '../../hooks/useShereCaseReducer'
import CustomModal from "../common/CustomModal"
import { commonTheme } from '../../materialui/theme'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')

const AdminTags = React.memo(() => {
  const history = useHistory()
  const {
    state: { loginUser, shareCase, admin },
    dispatch,
  } = useContext(GlobalContext)
  const { otherTagList, newTags } = shareCase
  const { checkNewTags } = admin

  // ローカルチェック状態
  const [checkedStates, setCheckedStates] = useState({})

  // 初期化とリセット
  useEffect(() => {
    setCheckedStates({ ...checkNewTags })
  }, [checkNewTags])

  // ログインチェックと初期データ取得
  useEffect(() => {
    if (!loginUser.isLogin) {
      loginActions.loginCheck(dispatch, history)
      return
    }
    if (!otherTagList.length) shareCaseActions.getOtherTags(dispatch)
    if (!newTags) shareCaseActions.getNewTags(dispatch)
    return () => dispatch({ type: 'COMMON_RESET' })
  }, [dispatch, history, loginUser.isLogin, otherTagList.length, newTags])

  // toggle handler
  const handleToggle = useCallback((key) => {
    setCheckedStates(prev => ({ ...prev, [key]: !prev[key] }))
  }, [])

  // derive list of selected requests
  const selectedKeys = useMemo(
    () => Object.keys(checkedStates).filter(key => checkedStates[key]),
    [checkedStates]
  )

  // delete handler
  const handleDelete = useCallback(() => {
    if (!selectedKeys.length) return
    // parse selectedKeys into id-list pairs, e.g. ['reqId___index']
    const toDelete = selectedKeys.map(key => {
      const [requestId, indexStr] = key.split('___')
      return { requestId, index: Number(indexStr) }
    })
    // dispatch batch deletion action (to be implemented in shareCaseActions)
    shareCaseActions.deleteNewTagRequests(dispatch, toDelete)
  }, [dispatch, selectedKeys])

  return (
    <MainTemplate>
      <CustomModal />
      <Container component={Card} style={{ margin: '40px 0' }}>
        <Typography variant="h6" style={{ margin: '20px 0 0' }}>
          タグの追加リクエスト一覧
        </Typography>
        <List>
          {newTags &&
            Object.entries(newTags).map(([id, tagGroup]) =>
              tagGroup.tag.map((tagItem, idx) => {
                const key = `${id}___${idx}`
                return (
                  <ListItem key={key} id={id} divider>
                    <ListItemText
                      primary={tagItem.label}
                      secondary={`user id: ${tagGroup.userId}`}
                    />
                    <Checkbox
                      edge="end"
                      checked={!!checkedStates[key]}
                      onChange={() => handleToggle(key)}
                    />
                  </ListItem>
                )
              })
            )}
        </List>
        <Button
          variant="contained"
          disabled={!selectedKeys.length}
          onClick={handleDelete}
          style={{
            marginTop: 16,
            // enabled のときだけ error 色を上書き
            ...(selectedKeys.length > 0 && {
              backgroundColor: commonTheme.palette.error.main,
              color: '#fff',
            }),
          }}
        >
          選択したタグリクエストを削除
        </Button>
      </Container>
    </MainTemplate>
  )
})

export default AdminTags
